import { z } from "zod";

export const SyncPricingFunctionResponseBodySchema = z.string();
export type SyncPricingFunctionResponseBodyType = z.infer<
  typeof SyncPricingFunctionResponseBodySchema
>;
